import { Directive, HostListener } from "@angular/core";

@Directive({
    selector: "[stop-click-bubble]",
    standalone: false
})
export class StopClickBubbleDirective 
{
  @HostListener("click", ["$event"])
  public onClick(event: any): void{
    event.stopPropagation();
  }
  
}